import React from 'react';
import { CHECKOUT_URL, PURCHASE_ANCHOR } from '../data/content';
interface CTAButtonProps {
  label: string;
  sub?: string;
  target?: 'purchase' | 'checkout';
  className?: string;
}
export function CTAButton({
  label,
  sub,
  target = 'purchase',
  className = ''
}: CTAButtonProps) {
  return <a href={target === 'checkout' ? CHECKOUT_URL : PURCHASE_ANCHOR} className={`block w-full rounded-md border-2 border-hazard-dark bg-hazard px-3 py-2.5 text-center font-display text-[0.95rem] font-extrabold uppercase leading-tight text-ink shadow-[0_5px_0_0_theme(colors.hazard.dark)] transition-[filter,transform,box-shadow] duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] hover:brightness-110 active:translate-y-[3px] active:shadow-[0_2px_0_0_theme(colors.hazard.dark)] focus:outline-none focus-visible:ring-4 focus-visible:ring-hazard/50 sm:text-[1.2rem] ${className}`} data-id="element-39" data-mp="2fz21wopnf0wk">
      {label}
      {sub ? <span className="mt-0.5 block font-sans text-[0.7rem] font-semibold normal-case text-ink/80 sm:text-xs" data-id="element-40" data-mp="38paappyao8yh">
          {sub}
        </span> : null}
    </a>;
}